import { animate, state, style, transition, trigger } from '@angular/animations';
import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, OnInit, OnDestroy } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Router } from '@angular/router';
import { Route } from '@models/route';
import { NewconService } from '@services/newcon.service';
import { catchError, debounceTime, EMPTY, Subject, retry } from 'rxjs';
import { MatDialog } from "@angular/material/dialog";


@Component({
  selector: 'app-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.scss'],
  animations: [
    trigger('slideVertical', [
      state('collapsed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      state('expanded', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      transition('collapsed <=> expanded', animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
      transition('void => expanded', animate('300ms ease-out')),
      transition('expanded => void', animate('300ms ease-in')),
    ]),
  ],
})
export class SubMenuComponent implements OnChanges, OnInit, OnDestroy {
  private readonly _redirectToNewconSubject = new Subject<Route>();

  @Output() emitCloseMenu: EventEmitter<void> = new EventEmitter();
  @Input() dataSource: MatTreeNestedDataSource<Route>;
  @Input() eixo: string;

  constructor(private newconService: NewconService, private router: Router, private readonly _dialog: MatDialog) { }

  handleNodeClick(node: Route) {
    if (node.action) {
      this._redirectToNewconSubject.next(node);
    } else if (node.path) {
        this.router.navigate([node.path]);
    }

    this.closeMenu();
  }



  public treeControl = new NestedTreeControl<Route>((node) => node.children);
  public isExpanded = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataSource'] && changes['dataSource'].currentValue) {
      this.treeControl.dataNodes = this.dataSource.data;
      this.treeControl.expandAll();
    }
  }

  ngOnInit(): void {
    this._redirectToNewconSubject.pipe(
      debounceTime(100)
    ).subscribe(route => {
      route.action(this.newconService, this._dialog);
    })
  }

  ngOnDestroy(): void {
    this._redirectToNewconSubject.unsubscribe();
  }
  public hasChild = (_: number, node: Route): boolean => !!node.children && node.children.length > 0;

  public returnDataCy(name: string): string {
    return `sub-menu--${name}`;
  }

  public closeMenu(): void {
    this.emitCloseMenu.emit();
  }
}
